import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import moment from "moment";
import get from "lodash/get";
import { useEffect, useState } from "react";
import CustomDatepicker from "../CustomDatepicker";
import history from "../../history";
import CartTitle from "../../components/CartTitle";
import Loader from "../Loader";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MultiSelect from "../MultiSelect";

import "../../assets/scss/components/MeterialTable/index.scss";

const _ = { get };

export default class Rentals extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: false,
      page: 0,
      phone: "",
      email: "",
      limit: 100,
      data: [],
      removeInput: false,
      exSupplier: [],
    };
  }
  removeExSupplierParent = (index) => {
    const temp = [...this.state.exSupplier];
    temp.splice(index, 1);

    this.setState([...temp]);
  };

  render() {
    let { elements } = this.props;

    return (
      <div className="hideSearch mt-4">
        <Form>
          <Row>
            <Col sm={12}>
              <CartTitle
                title="Rentals"
                Name={"Filter"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>

            <Col sm={12}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title font-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "memberShipDetailElements.subHeadingUserElement",
                            "Available Motorcycle"
                          )}
                        </span>
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="each_input mt-2" lg={4}>
                      <Label className="inputLabel">Select Motorcycles</Label>
                      <FormGroup className=" confirmRiderSelect select_options">
                        <Input
                          type="select"
                          name="City"
                          className="w-100 customeSelectBtn"
                          // value={parsedCountry}
                        >
                          <option>London</option>
                        </Input>
                      </FormGroup>
                    </Col>{" "}
                    <Col className="each_input mt-2" lg={4}>
                      <MultiSelect
                        placeholder="Thumbnail Image"
                        emails={this.state.exSupplier}
                        isImage={true}
                        onChange={(_emails) => {
                          const temp = [...this.state.exSupplier];
                          temp.push(_emails[0]);
                          this.setState({ exSupplier: [...temp] });
                        }}
                        getLabel={(email, index, removeEmail) => {
                          return (
                            <div data-tag key={index}>
                              {email}
                              <span
                                data-tag-handle
                                onClick={() => {
                                  this.removeExSupplierParent(index);
                                  removeEmail(index);
                                }}
                              >
                                ×
                              </span>
                            </div>
                          );
                        }}
                      ></MultiSelect>
                      <div className="image_rules">
                        Format: Jpg. Max Size: 1MB.
                      </div>
                    </Col>
                    <Col className="each_input mt-2" lg={4}>
                      <InputText
                        labelName="Add Url"
                        inputType={"text"}
                        inputName={"firstName"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "userMembershipListingFilterElements.firstNamePlaceholder",
                          "Add Url"
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="each_input" lg={4}>
                      <div className="add_row">Add Row</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="d-flex mt-5">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "landingPageElement.searchButtonElement",
                            "Save"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
